import { FilterField } from 'src/app/components/dialogs/select-filter-new/models/filter-field';
import { FieldDisplayType } from 'src/app/components/dialogs/select-filter-new/models/field-display-type';
import { SelectFilterComponent } from '../../select-filter/select-filter.component';
import { DynamicChoiceRepository } from './dynamic-choice-repository';
import { FieldValue } from '../models/field-value';
import { SavedFilter } from '../models/saved-filter';

export class FieldDeserializer {
  constructor(private choiceRepo: DynamicChoiceRepository) { }

  deserialize(allFields: FilterField[], existingFilter: SavedFilter, selectedFields: FieldValue[]) {
    const fieldsById = new Map<string, FilterField>();
    allFields.forEach(f => fieldsById.set(f.fieldId, f));
    existingFilter.fields.forEach(f => {
      if (!fieldsById.has(f.fieldId)) {
        console.warn(`${f.fieldId} is in filter JSON but not in set of possible fields. Field will not appear in UI.`);
        return;
      }

      const fieldMatch = fieldsById.get(f.fieldId);

      if (fieldMatch.displayType === FieldDisplayType.MultiSelect) {
        this.choiceRepo.loadChoicesFor(fieldMatch);

        for (let index = 0; index < f.value.length; index++) {
          if (f.value[index] === '') {
            f.value[index] = SelectFilterComponent.blank;
            break;
          }
        }
      }

      selectedFields.push({ field: fieldMatch, value: f.value });
    });
  }
}
